import { useState } from "react";
import { getStoredAccountType } from "../auth";
import { ApprovedInvoicesPage } from "./ApprovedInvoicesPage";
import { EnterpriseApprovedInvoicesPage } from "./EnterpriseApprovedInvoicesPage";

export function ApprovedInvoicesPageRouter() {
  const [accountType] = useState(() => getStoredAccountType());

  if (accountType === "enterprise") {
    return <EnterpriseApprovedInvoicesPage />;
  }

  return <ApprovedInvoicesPage />;
}
